<template>
    <div>
        <div class="text-subtitle-1 font-weight-medium">{{ $t('notify_client') }}:</div>
        <v-checkbox
            v-model="formData.clientNotificationsEnabled"
            density="compact"
            :label="$t('send_default_notifications_from_b2c')"
        />
        <div>{{ $t('e_mail_address_of_notifications_sender') }}:</div>
        <v-row no-gutters>
            <v-col cols="12 " sm="6" md="5">
                <v-text-field
                    v-model="formData.clientNotificationsSender"
                    type="email"
                    :rules="validationRules('email', [emailRule, requiredRule])"
                    required
                    @keydown.enter.prevent
                />
            </v-col>
        </v-row>
        <div class="text-subtitle-1 font-weight-medium">{{ $t('notify_manager') }}:</div>
        <v-checkbox
            v-model="formData.managerNotification"
            hide-details="auto"
            :label="$t('send_mail_notification_to_manager')"
        />
    </div>
</template>
<script setup lang="ts">
    const formData = defineModel<any>()
</script>
